import bgDevice from "/libs/assets/bg_device.jpg";
import bgLobby from "/libs/assets/bg_lobby_inno.jpg";
import logo from "/libs/assets/logo_inno.png";
 
const mateServer = "mate";
const mediaServer = "jitsi";

export const MateOptions = {
    style : {
        logo : {
            background: `url(${logo}) no-repeat center/cover`,
            width: "18.6em",
            minHeight: "4.9em"
        },
        smallLogo: {
            justifyContent: `center`,
            alignItems: `center`,
            background: `url(${logo}) no-repeat center/contain`,
            minWidth: "129px", height: "33px", display: "inline-block"
        },
        lobbyBackGround : {
            background: `url(${bgLobby}) no-repeat 65% center/cover fixed`,
        },
        nicknameBackGround: {
            background: `url(${bgLobby}) no-repeat 65% center/cover fixed`,
        },
        deivceBackGround: {
            background: `url(${bgDevice}) no-repeat 65% center/cover`,
        }
    },
    mateServer,
    mediaServer,
    connection: [mateServer, mediaServer],
    name: "innovation",
    lobby: {
        myPage: true,
        login: true,
        subText: `<div class='subTitle1'> 참여형 미디어 양방향 솔루션</div>
        <p class='subTitle2'>언제든 어디서든 <br/> <span style='font-weight: bold;'>비대면 학습지원</span></p>`
    },
    ui: {
        layout: {
            mode: {
                GRID_MODE: true,
                PINNED_MODE: true,
                VAD_MODE: true,
                SEMINAR_MODE: false,
                whiteboard: true,
                document: true,
                common_note: true,
                screenShare: true,
                vod: false
            },
            chat: {
                file: true,
                whisper: true,
                emotion: true,
                close: true
            },
            participant: {
                allPermission: true,
                invite: true,
                search: true,
                handler: true,
                pin: true,
                video: true,
                mic: true,
                kick: true,
                writing: true,
                changeRole: true,
                close: true
            },
            header: {
                logo: true,
                invite: false,
                attendance: false,
                fullScreen: false
            },
            container: {
                pin: true
            },
            footer: {
                video: true,
                mic: true,
                speaker: true,
                group: false
            },
            option: {
                fullScreen: false,
                blur: true,
                dualMonitor: true,
                recorder: true,
                setDevice: true,
                allPermission: true,
                survey: false,
                security: true,
                group: false,
                canvasRec: false
            }
        },
        function: {
            pin: true,
            chat: true,
            participant: true,
            security: {
                e2ee: false,
                lock: true
            },
            setDevice: {
                micTest: true,
                speakerTest: true
            },
            allPermission: {
                micOn: true,
                micOff: true,
                videoOn: true,
                videoOff: true,
                writingOn: true,
                writingOff: true
            },
            invite: {
                email: false,
                url: true
            },
            record: {
                local: true,
                server: true,
                canvasRec: false,
                startCanvasRec: false
            },
            mobile: {
                slider: true,
                hideUI: false
            },
            tempLogin: true
        }
    }
}